import React, { PureComponent } from 'react';
import styled, { keyframes } from "styled-components";

import Sizes from "../Assets/Sizes";
import { FormattedMessage } from 'react-intl';

import { pulse } from 'react-animations'
import { darken, lighten } from "../Common/Colors";
import Toast from "./Toast";


const lightSpeedInAnim = keyframes`${ pulse }`;

const FixedWrapper = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 100;
  visibility: ${ p => (p.loading || p.done) ? 'visible' : 'hidden' };
  transform: ${ p => p.done ? 'scale(0)' : 'none' };
  transform-origin: 50% 100%;
  opacity: ${ p => p.done ? 0 : 1 };
  transition: all 500ms;
`;

const RelativeContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;


const kSecondsToLoad = 10;
const kMaxAutoLoadingPercentages = 96;

const ConcreteLoader = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  max-height: ${ props => (props.done && 100) || (props.loading && 95) || 0 }%;
  left: 0;
  bottom: 0;
  background: linear-gradient(${ p => darken(p.theme.colors.primaryColor, 20) }, ${ p => lighten(p.theme.colors.secondaryColor, 20) });
  transition: all ${ props => !props.done ? kSecondsToLoad : 0.5 }s;
  opacity: 0.8;
  transition-timing-function: cubic-bezier(0, 0.2, 0.58, 1);
`;

const LoadingPercentages = styled.div`
  position: absolute;
  bottom: ${ Sizes.loaderBottomMargin };
  font-size: ${ Sizes.loaderFontSize };
  color: ${ p => p.theme.colors.safeText };
  text-align: center;
  animation: 1s ${ lightSpeedInAnim } infinite;
  width: 100%;
`;


class FullPageLoader extends PureComponent {
	state = {
		loading: 0,
		done: false
	};

	queue = [];

	componentDidMount() {
		setTimeout(() => {
			this.setState({ didMount: true });
		});
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		while (this.queue.length > 0) {
			this.queue.pop()();
		}
	}

	load(loadingText) {
		this.updateState({ loading: kMaxAutoLoadingPercentages, done: false, loadingText });
	}

	done() {
		this.updateState({ loading: 100, done: true, loadingText: undefined });
	}

	error(error) {
		this.toast.getWrappedInstance().show(error)
		this.updateState({ loading: 0, done: false, error, loadingText: undefined });
	}

	updateState(toMerge) {
		const updateState = () => this.setState(toMerge);
		if (this.state.didMount) {
			updateState()
		} else {
			this.queue.push(updateState);
		}
	}

	render() {
		const { loading, done } = this.state;
		return <FixedWrapper { ...this.state }>
			<RelativeContainer>
				<ConcreteLoader { ...this.state }/>
				{ (loading || done) && <LoadingPercentages>
					{ !this.state.loadingText &&
					<FormattedMessage id={ (loading && !done) ? 'general.searching' : 'general.done_searching' }/> }

					{ this.state.loadingText && <span>{ this.state.loadingText }</span> }
				</LoadingPercentages> }
			</RelativeContainer>
			<Toast ref={ (toast) => this.toast = toast }/>

		</FixedWrapper>
	}
}

export default FullPageLoader;
